import React from 'react';
import { Image } from 'react-native-web';
import { Android, keyboard_logo, The_keyboard } from '../../../../utils/DictionaryManagementUtils';
import { getImageByKey, img_android_screen_launch, img_ios_screen_launch } from '../../../../utils/ImagesManagementUtils';
import FullPageSimulator from '../FullPageSimulator';

//= ========================================================================
const LaunchKeyboardFP = ({
  globJSON,
  simPlatform,
  slideshowRefs,
}) => {
  const img_stub = getImageByKey(globJSON.configurations.services.menu.keyboard_logo, keyboard_logo);

  const myStyles = {
    hotkeyLogo: {
      width: 21,
      height: 21,
      marginLeft: 6,
      marginTop: simPlatform === Android ? 125 : 100,
      zIndex: 1,
    },
  };
  return (
    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      TopTitle={The_keyboard}
      WithImageBackground={simPlatform === Android ? img_android_screen_launch : img_ios_screen_launch}
      hidePhoneHeadLine
      hideIcons
      withOutTopVerticalLine
      slideshowRefs={slideshowRefs}
    >
      <Image
        fadeDuration={0}
        resizeMode="contain"
        style={myStyles.hotkeyLogo}
        source={img_stub}
      />
    </FullPageSimulator>

  );
};

export default LaunchKeyboardFP;
